import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { TabAllowedBySelectors } from '@vi-iot/ui';
import { AuthStore, LanguageStore, SUPPORTED_LANGUAGE } from '@store';
import { Subject, merge } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PaidFeature } from '../../../../projects/client';

@Component({
  selector: 'app-commercial-toolbar',
  templateUrl: './commercial-toolbar.component.html',
  styleUrls: ['./commercial-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialToolbarComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject();

  tabs: TabAllowedBySelectors[] = [
    {
      name: 'SHARED.SIDENAV.INSTALLATIONS',
      active: true,
      value: '/installations',
    },
    {
      name: 'SHARED.SIDENAV.INVITATIONS',
      active: true,
      value: '/invitations',
      selectors: merge(
        this.authStore.checkAvailableGlobalPaidFeaturePresence(PaidFeature.UserManagement),
        this.authStore.isUserWithRoleInvitation$
      ),
    },
    {
      name: 'SHARED.SIDENAV.UPDATES',
      active: true,
      value: '/updates',
    },
  ];

  constructor(public authStore: AuthStore, public languageStore: LanguageStore) {}

  ngOnInit(): void {
    this.checkSelectorsAndHideTab();
  }

  private checkSelectorsAndHideTab(): void {
    this.tabs.forEach((tab) => {
      if (tab.selectors) {
        tab.selectors
          .pipe(
            filter((val) => !val),
            takeUntil(this.ngUnsubscribe$)
          )
          .subscribe((val) => {
            tab.active = val;
          });
      }
    });
  }

  getDate(languageCode: SUPPORTED_LANGUAGE): string {
    return new Date().toLocaleDateString(languageCode, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
